const CLICK_IDS = {
    OBRA_PRIVADA_BUTTON_HOME: 'obra_privada_button_home',
    COTIZACION_MATERIALES_BUTTON_HOME: 'cotizacion_materiales_button_home',
    MURO_BUTTON_HOME: 'muro_button_home',
    OFERTA_DE_TRABAJO_BUTTON_HOME: 'oferta_de_trabajo_button_home',

}

export default CLICK_IDS;